// Primary public navigation. Each entry is shown only when its feature flag is on
// (src/config/publicFeatures.js). Routes themselves are never removed by hiding a link.
import { publicFeatures } from './publicFeatures';

export const PRIMARY_NAV = [
  { key: 'home', label: 'Home', to: '/', feature: 'home' },
  { key: 'categories', label: 'Categories', feature: 'categories', menu: 'categories' },
  { key: 'find-products', label: 'Find Products', to: '/filter', feature: 'search' },
  { key: 'buying-guides', label: 'Buying Guides', to: '/pages', feature: 'buyingGuides' },
  // Hidden by default; return automatically when their flags are enabled.
  { key: 'deals', label: 'Deals', to: '/daily-deals', feature: 'dailyDeals' },
  { key: 'trending', label: 'Trending', to: '/trending', feature: 'trending' },
  { key: 'compare', label: 'Compare', to: '/compare', feature: 'comparisons' },
];

export function getPrimaryNav(features = publicFeatures) {
  return PRIMARY_NAV.filter((item) => features[item.feature] === true);
}
